const commaSeparetedValue = (value, fraction = 2) => {
  return parseFloat(value).toLocaleString(undefined, {
    minimumFractionDigits: fraction
  });
};

export default commaSeparetedValue;
